import { map as _map, sortBy as _sortBy } from 'lodash-es';
import { useMemo } from 'react';
import AccountGroupNotificationsListItem from './group-notifications-list-item';
import type { GroupMember } from '../../types/GroupMember';

type Props = {
  groupMembers: GroupMember[];
  [key: string]: unknown;
};

const AccountGroupNotificationsList = ({ groupMembers, ...rest }: Props) => {
  const sortedGroupMembers = useMemo(() => {
    return _sortBy(groupMembers, 'group.name');
  }, [groupMembers]);

  return (
    <div {...rest}>
      {_map(sortedGroupMembers, (groupMember) => {
        return (
          <AccountGroupNotificationsListItem
            key={groupMember.id}
            groupMember={groupMember}
          />
        );
      })}
    </div>
  );
}

export default AccountGroupNotificationsList;
